const initialState = {
    data: null,
};
export const GetUserLedgerReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'GETUSERLEDGER_SUCCESS':
            return {
                ...state,
                data: action.payload,
            };
        case 'GETUSERLEDGER_FAILURE':
            return {
                ...state,
                error: action.payload
            };
        default:
            return state;
    }
}

export default GetUserLedgerReducer;